'use client';

import type React from 'react';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message }) => {
  return (
    <div className='flex flex-col items-center justify-center space-y-4 py-10'>
      <div className='border-primary h-12 w-12 animate-spin rounded-full border-4 border-t-4'></div>
      {message ? <span className='text-primary text-lg'>{message}</span> : <span className='sr-only'>Loading...</span>}
    </div>
  );
};

export default LoadingSpinner;
